import { NakedFormSelect } from './naked-form-select';
import { isMobile } from '../services/mql-service';

class LocationsSearchFormFilters extends DrupalBehavior {
  onContent(context) {
    const baseNfsOptions = {
      formElement: context,
    };
    const locationTypeNfsOptions = {
      ...baseNfsOptions,
      customMultiSelectedTextOptions: {
        customMultiText: 'location types selected',
      },
      placeholder: 'Search location types',
    };

    const specialtiesNfsOptions = {
      ...baseNfsOptions,
      customMultiSelectedTextOptions: {
        customMultiText: 'specialties selected',
      },
      placeholder: 'Search specialties',
    };

    new NakedFormSelect({
      ...locationTypeNfsOptions,
      target: 'select#edit-location-type--2',
    }).setUpNakedFormSelectAccordion();

    new NakedFormSelect({
      ...locationTypeNfsOptions,
      target: 'select#edit-location-type',
    }).setUpNakedFormSelectDropdown();

    new NakedFormSelect({
      ...specialtiesNfsOptions,
      target: 'select#edit-specialty--2',
    }).setUpNakedFormSelectAccordion();

    new NakedFormSelect({
      ...specialtiesNfsOptions,
      customMultiSelectedTextOptions: {
        ...specialtiesNfsOptions.customMultiSelectedTextOptions,
        enableNumberToken: true,
      },
      target: 'select#edit-specialty',
    }).setUpNakedFormSelectDropdown();

    new NakedFormSelect({
      ...baseNfsOptions,
      target: 'select#edit-sort',
      singleSelectOptions: {
        isSingleSelect: true,
        hideSearch: true,
      },
    }).setUpNakedFormSelectDropdown({ fullScreenMobile: false });

    this.disableSelectsBasedOnScreenSize();
  }

  disableSelectsBasedOnScreenSize() {
    if (isMobile()) {
      this.disableSelects('.locations-search-form--filters--desktop');
    } else {
      this.disableSelects('.locations-search-form--filters--mobile');
    }
  }

  disableSelects(selector) {
    document
      .querySelector(selector)
      .querySelectorAll('select')
      .forEach((select) => (select.disabled = true));
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'locations_search_form__filters',
  LocationsSearchFormFilters
);
